const PRICE_AGREEMENTS = [
	{id: 'discount_pct', t: 'records.default.fields.discount_pct'},
	{id: 'discount_amt_per_user', t: 'records.default.fields.discount_amt_per_user'},
	{id: 'fixed_amt_per_env', t: 'records.default.fields.fixed_amt_per_env'},
]

export const usePriceAgreementFilter = () => {
	const filterFn = (item, filterValues) => filterValues.some(value => Boolean(item[value]))

	return {
		items: PRICE_AGREEMENTS,
		filterFn,
	}
}
